<template>
  <div class="misc-wrapper">
    <div class="misc-inner p-2 p-sm-3">
      <div class="w-100 text-center">
        <h2 class="mb-1">
          {{ error ? 'Не удалось войти' : 'Входим в Cubus…' }}
        </h2>
        <p class="mb-2">
          {{ error || 'Секунду: проверяем сессию и открываем домен.' }}
        </p>
        <b-spinner
          v-if="!error"
          variant="primary"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { BSpinner } from 'bootstrap-vue'
import useJwt from '@/cubus/jwt/useJwt'
import { getHomeRouteForLoggedInUser } from '@/auth/utils'

/**
 * SSO-переход из продуктового фронта: /sso?token=...&domainsid=... (или ?code=... —
 * одноразовый exchange-код, обменивается на /api/sso/exchange).
 * Принимает готовый токен сессии, при необходимости переключает домен
 * и заводит пользователя сразу в рабочее место.
 *
 * CUB-953: перенос из frontend-vue/new-front (CbsSso.vue + BUG-301) в main. `setCubusToken`
 * здесь НЕ зовётся (в отличие от исходной версии) — в main это осознанный no-op с PROP-086:
 * аутентификацию браузера несёт httpOnly-cookie, которую сервер уже ставит ответом `whoami`
 * (см. `withRenewedSessionCookie` в `CubusController.whoami`); токен для AI-фич живёт в Vuex
 * (SET_SESSION ниже), как и в CbsLogin.vue.
 */
export default {
  name: 'CbsSso',
  components: { BSpinner },
  data() {
    return { error: null }
  },
  async mounted() {
    const { code, domainsid, next } = this.$route.query
    let { token } = this.$route.query
    if (code && !token) {
      // одноразовый exchange-код: токен не светится в URL
      try {
        const res = await useJwt.axiosIns.post('/api/sso/exchange', { code })
        token = res.data && res.data.token
      } catch (e) {
        token = null
      }
    }
    if (!token) {
      this.$router.replace('/login')
      return
    }
    try {
      let session = await this.whoami(token)
      if (domainsid && session.domain && session.domain.sid !== domainsid) {
        await useJwt.axiosIns.post(
          '/api/domain/switch',
          { domainsid },
          { headers: { Authorization: `Bearer ${token}` } },
        )
        session = await this.whoami(token)
      }
      this.$store.commit('cubus-store/SET_SESSION', session)
      localStorage.setItem('userData', JSON.stringify(session.user))
      this.$ability.update([{ action: 'manage', subject: 'all' }])
      // next — внутренний путь (например /cubus-object/123): сразу в нужный объект
      const target = next && String(next).startsWith('/') ? String(next) : getHomeRouteForLoggedInUser(session.user.role.name)
      this.$router.replace(target)
    } catch (e) {
      this.error = (e && e.message) || 'Сессия недействительна'
      setTimeout(() => this.$router.replace('/login'), 2000)
    }
  },
  methods: {
    async whoami(token) {
      const res = await useJwt.whoami({ token })
      if (!res.data || !res.data.session) {
        throw new Error((res.data && res.data.error) || 'Сессия не найдена')
      }
      return res.data.session
    },
  },
}
</script>

<style lang="scss">
@import '~@core/scss/base/pages/page-misc.scss';
</style>
